<div class="wrapper">
    <p class="landing-title">Your retirement healthcare center</p>
    <p class="landing-sub-title">Helping you better prepare for healthcare expenses during retirement</p>
    <p class="landing-description">Retirement brings a lot of changes, including how you take care of your medical needs. This tool helps you better understand what your healthcare might cost in retirement and how an HSA can help you save for those expenses.
    </p>
    <div class="button-container">
        <button class="button-landing-one filled-green-button" (click)="next()" (keyup.enter)="next()" tabindex=0>Run projection</button>
        <div class="button-landing-two" (click)="redirectFormPage()">Learn about Medicare</div>
    </div>
</div>


